import { ApolloError, isApolloError } from "@apollo/client";

// Codes startPickingOrder returns when picking-service refuses to start: the hub has nothing to
// pick (pharmacy-only or dm order), or the delivery isn't live (customer editing it, or cancelled).
export const START_PICKING_REFUSAL_CODES = [
  "PICKING_ORDER_NO_HUB_PICKUP",
  "PICKING_ORDER_NO_LIVE_DELIVERY",
] as const;

export type StartPickingRefusalCode = (typeof START_PICKING_REFUSAL_CODES)[number];

export function getStartPickingRefusalCode(error: unknown): StartPickingRefusalCode | null {
  if (!(error instanceof Error) || !isApolloError(error)) return null;
  const code = (error as ApolloError).graphQLErrors?.[0]?.extensions?.code;
  return START_PICKING_REFUSAL_CODES.find((refusalCode) => refusalCode === code) ?? null;
}
